module.exports = __webpack_public_path__ + "img/FooterLogoCircle.0ddb81f7.png";